import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var paymentMethodDiscoverIcon = /*#__PURE__*/React.createElement("svg", {
  height: "35",
  width: "56",
  viewBox: "0 0 56 35",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M3.948 0C1.768 0 0 1.72 0 3.84v27.29c0 2.121 1.768 3.84 3.948 3.84h48.104c2.18 0 3.948-1.72 3.948-3.84V3.84C56 1.718 54.232 0 52.052 0H3.948Z",
  fill: "#FFF",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55.999 20.128c-1.87 1.28-15.873 10.424-40.116 14.84h36.168c2.18 0 3.948-1.718 3.948-3.839V20.127Z",
  fill: "#F47216",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.5 28.694h4V34.5h-4z",
  fill: "#F47216",
  stroke: "#F47216"
}), /*#__PURE__*/React.createElement("path", {
  d: "M51.5.5h4v5.806h-4zM.5.5h4v5.806h-4zm0 28.194h4V34.5h-4z",
  fill: "#FFF",
  stroke: "#FFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.488 11.3c.634 0 1.166.125 1.814.425v1.588c-.613-.549-1.146-.778-1.85-.778-1.382 0-2.47 1.048-2.47 2.376 0 1.402 1.054 2.387 2.54 2.387.668 0 1.19-.217 1.78-.757v1.588c-.67.29-1.214.404-1.85.404-2.245 0-3.99-1.578-3.99-3.612 0-2.012 1.792-3.62 4.026-3.62Zm-6.972.044c.829 0 1.587.26 2.221.767l-.771.925c-.385-.394-.748-.56-1.19-.56-.635 0-1.098.33-1.098.767 0 .373.26.571 1.145.871 1.677.561 2.174 1.06 2.174 2.159 0 1.34-1.075 2.272-2.607 2.272-1.123 0-1.938-.405-2.618-1.317l.953-.84c.34.6.906.923 1.61.923.657 0 1.144-.416 1.144-.976 0-.29-.147-.54-.442-.716-.148-.084-.442-.208-1.02-.394-1.384-.457-1.86-.945-1.86-1.898 0-1.132 1.02-1.983 2.359-1.983Zm18.462.12 2.017 4.649 2.042-4.648h1.599l-3.267 7.097h-.793l-3.208-7.097h1.61Zm-30.138.011h2.165c2.391 0 4.058 1.423 4.058 3.465 0 1.019-.51 2.003-1.372 2.657-.726.551-1.553.798-2.698.798H4.84v-6.92Zm6.902 0h1.475v6.92h-1.475v-6.92Zm29.56 0h4.183v1.173h-2.709v1.536h2.609v1.172h-2.609v1.868h2.709v1.171h-4.183v-6.92Zm5.16 0h2.186c1.7 0 2.675.748 2.675 2.043 0 1.06-.61 1.755-1.722 1.962l2.38 2.915h-1.813l-2.041-2.78h-.193v2.78h-1.473v-6.92Zm1.472 1.09v2.096h.431c.942 0 1.441-.374 1.441-1.07 0-.673-.5-1.026-1.418-1.026h-.454Zm-41.62.083v4.576h.395c.953 0 1.555-.167 2.019-.55.51-.416.816-1.08.816-1.744 0-.663-.307-1.307-.816-1.723-.488-.403-1.066-.56-2.019-.56h-.395Z",
  fill: "#000",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M29.462 11.252a3.679 3.679 0 0 1 3.68 3.68v.002a3.68 3.68 0 1 1-7.36 0v-.002a3.679 3.679 0 0 1 3.68-3.68Z",
  fill: "#F47216",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56 0v35H0V0h56Zm-1 1H1v33h54V1Z",
  fill: "#DADADA",
  fillRule: "nonzero"
})));

export { paymentMethodDiscoverIcon as default };
//# sourceMappingURL=paymentMethodDiscoverIcon.js.map
